// extracted by mini-css-extract-plugin
module.exports = {"text":"ViewMoreBlock_text__3LGz4"};